import React from 'react';
import { useTranslation } from 'react-i18next';
import type { ChannelDistributionItem } from '../../../../api/queries';
import classes from './SimpleChannelDistribution.module.css';

export interface SimpleChannelDistributionProps {
  data: ChannelDistributionItem[];
}

/**
 * Simple channel list showing configured channels
 */
export const SimpleChannelDistribution: React.FC<SimpleChannelDistributionProps> = ({ data }) => {
  const { t } = useTranslation();

  if (!data || data.length === 0) {
    return (
      <div className={classes.container}>
        <p className={classes.noData}>{t('usage.details.channels.noChannels')}</p>
      </div>
    );
  }

  return (
    <div className={classes.container}>
      <div className={classes.channelsList}>
        {data.map((item) => (
          <span key={item.channel} className={classes.channelTag}>
            {item.channel}
          </span>
        ))}
      </div>
    </div>
  );
};
